import { render, staticRenderFns } from "./CellosignIframe.vue?vue&type=template&id=448b8e34&scoped=true"
import script from "./CellosignIframe.vue?vue&type=script&lang=js"
export * from "./CellosignIframe.vue?vue&type=script&lang=js"
import style0 from "./CellosignIframe.vue?vue&type=style&index=0&id=448b8e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448b8e34",
  null
  
)

export default component.exports